export const DEFAULT_SERVICE_FEE_LABEL = '服務費'

// 非字串 → null；控制字元 U+0000–U+001F、U+007F 換成空白後 trim；空字串 → null
export function normalizeServiceFeeName(value) {
  if (typeof value !== 'string') return null
  // 契約要求清理控制字元，保留指定的判斷式。
  // eslint-disable-next-line no-control-regex
  return value.replace(/[\x00-\x1f\x7f]/g, ' ').trim() || null
}

export function getServiceFeeLabel(value) {
  return normalizeServiceFeeName(value) || DEFAULT_SERVICE_FEE_LABEL
}
